import React from 'react'
import WhitePanel from '../../UI/white-panel/whitePanel'
//import { fetchData } from '../../action/action'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import SearchBar from '../../UI/search-bar/searchBar'
import { movies, CMSPath } from '../../config/constant'
import { setVideoPlayer } from '../../action/action'
import { fetchMovieList } from '../../action/moviesAction'
import { token } from '../../config/constant'
import DefaultImage from '../../images/movie_thumb.png'
import { MovieSearchColor } from '../../JS/setColors'

class Movies extends React.Component {

  componentDidMount() {
    MovieSearchColor(this.props.menuColor);
    let sessionToken = localStorage.getItem('GuestJourneySessionToken');
    if (sessionToken) {
      this.props.fetchMovieList("/videolist/fetch", sessionToken);
    }
  }

  onPlayClick = (videoUrl) => {
    //console.log("videoUrl", videoUrl);
    let videoPath
    if (videoUrl) {
      videoPath = videoUrl.slice(0, 4);
      if (videoPath === "http") {
        videoPath = videoUrl;
        this.props.setVideoPlayer(true, videoPath);
      } else if (videoPath === "/../") {
        videoPath = `${CMSPath}${videoUrl}`
        this.props.setVideoPlayer(true, videoPath);
      } else {
        alert("video is not available");
      }
      //console.log("videoPath", videoPath);
    } else {
      this.props.setVideoPlayer(true, `${CMSPath}/../cmsData/videos/SESTHIS_3189_GuesMagicAI.mp4`);
    }
  }

  render() {
    let image
    //-- /movies <- path for API
    //console.log("this.props.videoList", this.props.videoList);
    return (
      <div id="movies" className="contentSection">
        <SearchBar list={movies} />
        <div className="movie-container">
          <WhitePanel
            title={`${this.props.stringConst.movieList}`}
            styleClasses="movie-list">
            <ul className="movie-list-items">
              {this.props.videoList.length > 0 ?
                this.props.videoList.map((iterator) => {
                  if (iterator.imageUrl) {
                    if (iterator.imageUrl) {
                      image = iterator.imageUrl.slice(0, 4);
                      if (image === "http") {
                        image = iterator.imageUrl;
                      } else {
                        image = `${CMSPath}${iterator.imageUrl}`
                      }
                    }
                  } else {
                    image = DefaultImage;
                  }
                  return (
                    <li
                      className="movie-item"
                      onClick={() => { this.onPlayClick(iterator.videoUrl) }}

                      style={{
                        backgroundImage: `url('${image}')`,
                        backgroundSize: 'cover'
                      }}>
                      <i class="fa fa-play"></i>
                    </li>
                  )
                }) :
                <div className="activity-item-name all-caps">
                  {this.props.stringConst.VideoNotFound}
                </div>
              }
            </ul>
          </WhitePanel>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    stringConst: state.store.home.stringConst,
    videoList: state.store.movies.videoList,
    menuColor: state.store.home.MenuColor
  }
}

Movies.propTypes = {
  stringConst: propTypes.object,
}

export default connect(
  mapStateToProps,
  {
    setVideoPlayer,
    fetchMovieList
  }
)(Movies);

/*
movies.map((iterator) => {
  return (
    <li
      className="movie-item"
      onClick={() => { this.onPlayClick(null) }}
      style={{
        backgroundImage: `url('${iterator.image}')`,
        backgroundSize: 'cover'
      }}>
      <i class="fa fa-play"></i>
    </li>
  )
})
*/